import React from 'react'
import './about.css'
import Footer from '../Footer/Footer'
import servicebg from '../../../assets/packages.jpg'
import Image1 from '../../../assets/images/img1.jpg'
import Emma from '../../../assets/images/emma.jpg'
import teamPhoto from '../../../assets/images/team.jpg' // You'll need to add this image
import historyImage from '../../../assets/images/history.png' // You'll need to add this image
import valuesImage from '../../../assets/images/values.jpg' // You'll need to add this image

import { GiHouse } from 'react-icons/gi'
import { MdArchitecture } from 'react-icons/md'
import { FaPeopleArrows } from 'react-icons/fa'
import { FaHandshake } from 'react-icons/fa'
import { FaLightbulb } from 'react-icons/fa'
import { FaChartLine } from 'react-icons/fa'
import { FaGlobe } from 'react-icons/fa'

const AboutUs = () => {
    return (
        <div>
            <div className='about'>
                {/* Hero Section */}
                <section className="section1">
                    <div className='service-image'>
                        <img src={servicebg} alt="Diamond Energy" />
                        <div className='service-overlay'></div>
                    </div>
                    <div className="text">
                        <h1>About Us</h1>
                        <div 
                            data-aos="fade-right"
                            data-aos-easing="linear"
                            data-aos-duration="1000"
                            className="block">
                        </div>
                    </div>
                </section>

                {/* Our Story Section */}
                <section className="section2">
                    <div className="text">
                        <div className='text-story'>
                            <h1>Our Story</h1>
                            <h3> Helix Energy Solutions in brief.</h3>
                            <p>
                             Helix Energy Solutions is an international energy company present in more than 14 countries worldwide, including several of the world’s most important oil and gas provinces.
                            </p>
                            <p> 
                            Founded in 1995 under the name  Helix Energy Holdings, we changed our name to  1999 to Helix energy solutions. Our headquarters is in Los Angeles, California and we have over 2,000 employees.
                            </p>
                            <p>
                            In all our business activities we comply with applicable laws, act in an ethical, sustainable and socially responsible manner, practise good corporate governance and respect internationally recognised human rights. 
                            </p>
                            <p>
                            We maintain an open dialogue on ethical issues — both internally and externally. Open, honest and accurate communication is essential to our integrity and business success.
                            </p>
                        </div>
                    </div>
                    <div className='service-image'>
                        <img src={Image1} alt="Diamond Energy Team" />
                        <div className='service-overlay'></div>
                    </div>
                </section>

                {/* What We Do Section */}
                <section className="section-what-we-do">
                    <div className="section-header">
                        <h1>What We Do</h1>
                        <p>Diamond Energy delivers excellence across multiple energy sectors</p>
                    </div>
                    <div className='services-grid'>
                        <div className='service-box'>
                            <MdArchitecture className='icon'/>
                            <h3>Oil Exploration</h3>
                            <p>Utilizing cutting-edge technology to discover new oil reserves with minimal environmental impact.</p>
                        </div>

                        <div className='service-box'>
                            <GiHouse className='icon'/>
                            <h3>Commercial Operations</h3>
                            <p>Managing large-scale commercial energy projects with efficiency and strategic insight.</p>
                        </div>

                        <div className='service-box'>
                            <FaPeopleArrows className='icon'/>
                            <h3>Gas Production</h3>
                            <p>Sustainable extraction and processing of natural gas resources for global energy markets.</p>
                        </div>

                        <div className='service-box'>
                            <FaGlobe className='icon'/>
                            <h3>Global Distribution</h3>
                            <p>Seamless logistics and transportation networks delivering energy products worldwide.</p>
                        </div>
                    </div>
                </section>

                {/* Our History Section */}
                <section className="section-history">
                    <div className='history-image'>
                        <img src={historyImage} alt="Diamond Energy History" />
                    </div>
                    <div className="history-content">
                        <h1>Sustainability</h1>
                        <div className="timeline">
                            <div className="timeline-item">
                                <p>Can an oil and gas company be part of a sustainable energy future? We are working actively to reduce climate emissions, put a price on carbon, and benefit societies around the world. We are determined to develop resources responsibly and create lasting value for communities. Our industry needs to be part of the solution. We aim to be recognized as the most carbon-efficient oil and gas producer, committed to creating lasting value for communities.</p>
                            </div>

                            <div className="timeline-item">
                                <p>In all our business activities we comply with applicable laws, act in an ethical, sustainable and socially responsible manner, practise good corporate governance and respect internationally recognised human rights. We maintain an open dialogue on ethical issues — both internally and externally. Open, honest and accurate communication is essential to our integrity and business success.</p>
                            </div>
                            
                        </div>
                    </div>
                </section>

                {/* Our Values Section */}
                <section className="section-values">
                    <div className="values-content">
                        <h1>Our Values</h1>
                        <div className="values-grid">
                            <div className="value-item">
                                <FaHandshake className="value-icon" />
                                <h3>Respecting people</h3>
                                <p>We conduct business with unwavering honesty and transparency</p>
                            </div>
                            <div className="value-item">
                                <FaLightbulb className="value-icon" />
                                <h3>Working with communities</h3>
                                <p>Constantly seeking better solutions to energy challenges</p>
                            </div>
                            <div className="value-item">
                                <FaChartLine className="value-icon" />
                                <h3>Relating to business partners</h3>
                                <p>Maintaining the highest standards in all aspects of our operations</p>
                            </div>
                        </div>
                    </div>
                    <div className='values-image'>
                        <img src={valuesImage} alt="Diamond Energy Values" />
                    </div>
                </section>

                {/* Our Team Section */}
                <section className="section-team">
                    <div className="section-header">
                        <h1>Our Team</h1>
                        <p>Diamond's success is built on the expertise of our people</p>
                    </div>
                    <div className="team-image">
                        <img src={teamPhoto} alt="Diamond Energy Team" />
                    </div>
                    <div className="team-stats">
                        <div className="stat">
                            <h2>250+</h2>
                            <p>Employees Worldwide</p>
                        </div>
                        <div className="stat">
                            <h2>15</h2>
                            <p>Countries</p>
                        </div>
                        <div className="stat">
                            <h2>35+</h2>
                            <p>Years Experience</p>
                        </div>
                    </div>
                </section>

                {/* CEO Section */}
                <section className='section-ceo'>
                    <div className='ceo-content'>
                        <div className='ceo-image'>
                            <img src={Emma} alt="Edward Garrett - CEO" />
                        </div>
                        <div className='ceo-info'>
                            <h1>Edward Garrett</h1>
                            <h2>Chief Executive Officer</h2>
                            <p>"Our clients depend on our construction and exploration services to gain a competitive edge in their projects. At  Helix Energy Solutions, we understand that these services must be robust, flexible, and, above all, clear and transparent. Too often, crucial tasks are delegated to the least experienced team members; at  Helix Energy Solutions, we assign these critical responsibilities to senior-level management, ensuring the highest standards of expertise and precision."</p>
                            <p>The CEO went to Texas A&M uni and earned his Bachelor's degree in Petroleum Engineering and his master's in Energy, Environment and Natural Resources Law
                            </p>
                            <blockquote>
                                "At  Helix Energy Solutions, we believe in powering progress through responsible energy solutions that serve both our clients and communities."
                            </blockquote>
                        </div>
                    </div>
                </section>
            </div>

            <Footer />
        </div>
    )
}

export default AboutUs